import convertRate from "./convertRate";

const scanPrice = (
  pricing,
  value,
  exchangeRate = 1,
  originExchangeRate = 1,
  numberFormat = 1,
  rounded = false,
  pricingLevel = false
) => {
  let tmp = 0;
  let price = 0;

  if (pricing) {
    pricing.forEach((v) => {
      const val = convertRate(
        v.value,
        exchangeRate,
        originExchangeRate,
        numberFormat,
        rounded
      );

      if (parseFloat(value) > tmp && parseFloat(value) <= val) {
        if (pricingLevel) {
          price =
            Math.round(
              parseFloat(
                (value > 0 ? v.minPrice : 0) +
                  convertRate(
                    value,
                    1 / exchangeRate,
                    1 / originExchangeRate,
                    1 / numberFormat,
                    rounded
                  ) *
                    (v.percent / 100)
              ) / 10
            ) * 10;
        } else {
          price = v.price;
        }
      }
      tmp = val;
    });
  }

  return price;
};

export default scanPrice;
